export default __webpack_public_path__ + "static/travel-e93be525e7aa8b5b951f498d13dc0c81.png";